import { Injectable } from '@angular/core';
import * as moment from 'moment';
import * as timeZone from 'moment-timezone';

@Injectable()
export class DateUtils {
  public static getLocalTime(time) {
    const nDate = new Date(time);
    const localZone = timeZone.tz.guess();
    const timezone = timeZone.tz(localZone).zoneAbbr();
    const localTime = moment.utc(nDate).local().format('MMM DD YYYY, HH:mm');
    return `${localTime} ${timezone}`;
  }

  public static getLocalDateFormat(date) {
    const dummyDate = new Date (date);
    const localZone = timeZone.tz.guess();
    const timezone = timeZone.tz(localZone).zoneAbbr();
    const localDate = moment.utc(dummyDate).local().format('MMM DD YYYY');
    return `${localDate}`;
  }

  public static getLocalTimeWithDay(time) {
    const nDate = new Date(time);
    const localZone = timeZone.tz.guess();
    const timezone = timeZone.tz(localZone).zoneAbbr();
    const localTime = moment.utc(nDate).local().format('ddd MMM DD YYYY, HH:mm');
    return `${localTime} ${timezone}`;
  }

  public static getTimeZoneAbbr() {
    const nDate = new Date();
    const localZone = timeZone.tz.guess();
    const timezone = timeZone.tz(localZone).zoneAbbr();
    return timezone;
  }

  public static getUTCMillies(date) {
    const utc = moment.utc(date).valueOf();
    return utc;
  }

  public static getSelectedLocalTime(dateValue, time) {
    const dt = dateValue + ' ' + time;
    const nDate = new Date(dt);
    const localTime = moment.utc(nDate).format('YYYYMMDDHHMMSS');
    return localTime;
  }

  public static getUpdateCaseLocalTime(dateValue) {
    const dt = dateValue;
    const nDate = new Date(dt);
    const year = nDate.getUTCFullYear();
    const month = (nDate.getUTCMonth()) + Number(1);
    const monthValue = ('0' + month).slice(-2);
    const day = nDate.getUTCDate();
    const dayValue = ('0' + day).slice(-2);
    const hours = nDate.getUTCHours();
    const hoursValue = ('0' + hours).slice(-2);
    const minutes = nDate.getUTCMinutes();
    const minutesValue = ('0' + minutes).slice(-2);
    const seconds = nDate.getUTCSeconds();
    const secondsValue = ('0' + seconds).slice(-2);
    const dtFormat = year + '' + monthValue + '' + dayValue + '' + hoursValue + '' + minutesValue + '' + secondsValue;
    return dtFormat;
  }

  public static getLocalTimeFromUTC(time) {
    const stillUtc = moment.utc(time).toDate();
    const localTime = moment(stillUtc).local().format('ddd MMM DD YYYY, HH:mm');
    const localZone = timeZone.tz.guess();
    const timezone = timeZone.tz(localZone).zoneAbbr();
    return `${localTime} ${timezone}`;
  }
}
